import { FetchPolicy } from '@apollo/client';

export const DISABLED_CLASS = 'opacity-50';
export const INPUT_FIELD_MAX_LENGTH = 100;
export const DISPLAY_MESSAGE_RIGHT = 130;
export const TEXTAREA_MAX_LENGTH = 1000;
export const SMALL_CLOSE_ICON_SIZE = 8;
export const START_YEARS = 1990;
export const END_YEARS = 2100;
export const NEXT_ELEMENT = 1;
export const TO_LAST_ELEMENT = 1;
export const PENALTY_RETRY = 1;
export const PENALTY_SPOT = 1;
export const NUMBER_DATA_ALLOW = 1;
export const ARRAY_FIRST_ELEMENT = 0;
export const ERROR_VERSION = 0;
export const EMPTY = 0;
export const NOT_FOUND_CODE = -1;
export const FOUND_CODE = 1;
export const STATUS_ERROR_RETRY = 500;
export const DATETIME_FORMAT = 'DD MMM yyyy hh:mma';
export const CUSTOM_FIELD_KEYWORD = 'custom';
export const HEADER_TYPE = 'header';
export const FOOTER_TYPE = 'footer';
export const CUSTOM_DATE_RANGE = 'Custom';
export const BEGIN_DATE = '0D';
export const DATE_EXPRESSTION = 'calc:';
export const COLON = ':';
export const MINUS_KEYWORD = '-';
export const DAY_KEYWORD = 'D';
export const MONTH_KEYWORD = 'M';
export const YEAR_KEYWORD = 'Y';
export const DATA_TYPE_DATE_SINGLE = 'DateSingle';
export const DATA_TYPE_DATE_RANGE = 'DateRange';
export const DATA_TYPE_LIST_MULTI_SELECT = 'ListMultiSelect';
export const DATA_TYPE_LIST_SINGLE_SELECT = 'ListSingleSelect';
export const COMPANY_KEYWORD = 'ListCompany';
export const DATA_TYPE_YES_NO = 'YesNo';
export const DATA_TYPE_FREE_TEXT = 'FreeText';
export const HEIGHT_SWITCH = 20;
export const WIDTH_SWITCH = 36;
export const TOGGLE_SIZE = 13;
export const REPORTID_KEYWORD = ':reportId';
export const DEFAULT_VERSION_ID = 1;
export const TAB_SAVE_REPORT = 'UserReport';
export const ON_LOADING = 'Loading...';
export const APP_COLOR = {
  'main-ui-blue': '#0177BD',
  'drop-down-grey': '#E7E8E9',
  'lighter-grey': '#757575',
  'border-grey': '#d8d8d8',
  'field-grey': '#f1f3f3',
  'table-header': '#D5DCE1',
  'table-header-text': '#28282F',
  'icon-green': '#2f7d33',
  'icon-orange': '#dc9037',
  'icon-default': '#CECFD3',
  'icon-white': '#fff',
  'icon-grey': '#9fa3a9',
  'tooltip-default': '#014771',
  'index-col-blue': '#E7EBEE',
  'warning-yellow': '#DC9037',
  white: '#FFFFFF',
  'grey-close-icon': '#878B93',
  'grey-arrow-sort': '#B6B9BE',
};

export const APP_LENGTH = {
  '6': '6px',
  '18': '18px',
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const RUN_REPORT_PARAMS_LOCAL_STORAGE = 'runReportParams';
export const INACTIVE_TIMEOUT = 0.15 * 60 * 1000;
export const INACTIVE_DECOUNCE = 500;
export const LOGOUT_TIMEOUT = 2 * 60 * 1000;
export const LOCAL_STORAGE_INACTIVE_POPUP_ACTION = 'inactive-popup-action';
export const LOCAL_STORAGE_IS_INACTIVE_IN_ONE_TAB = 'is-inactive-in-one-tab';
export const CHECK_INACTIVE_ACTION_INTERVAL = 500;
export const IDLE_EVENTS = [
  'mousemove',
  'keydown',
  'wheel',
  'scroll',
  'mousedown',
  'touchstart',
  'touchmove',
];
export const DEFAULT_CALLBACK_DEBOUNCE = 500;
export const LOCAL_STORAGE_INTERVAL_DELAY = 500;
export const LOCAL_STORAGE_IDLE_HANDLER = 'idle-handler';
export const LOCAL_STORAGE_IDLE_ACTION_ID = 'idle-action-id';
export const LOCAL_STORAGE_AUTH_TIME = 'auth_time';
export const DEFAULT_RUN_REPORT_OFFSET = 0;
export const RUN_REPORT_PAGE_SIZE = 50;
export const RUN_REPORT_TOTAL_PAGES_LIMIT = 4;
export const DEFAULT_RUN_REPORT_LIMIT =
  RUN_REPORT_PAGE_SIZE * RUN_REPORT_TOTAL_PAGES_LIMIT;
export const NO_CONTENT_STRING = '204';
export const DEFAULT_RUN_REPORT_FIRST_PAGE = 1;
export const POLLING_DELAY = 2000;
export const MAX_POLLING_DURATION = 1800000;
export const POLLING_TIMEOUT_ERROR_MSG = 'Polling Timeout';
export const POLLING_ERROR_MSG = 'Error in running report';
export const REPORT_EXPIRED_ERROR_MSG = 'Report timed out, please re-run';
export const REPORT_READY_MSG = 'Your report is ready. Click here to open it.';
export const EXPORT_ERROR_MSG = 'Error in exporting report';
export const EXPORT_NO_DATA = 'Error in exporting report (No Data)';
export const APOLLO_NO_CACHE_POLICY: FetchPolicy = 'network-only';
export const DATA_GRID_CELL_HEIGHT = 53;
export const DOWNLOAD_EMPTY_FILE_NAME_ERROR_MSG =
  'The download filename is empty';
export const DOWNLOAD_EMPTY_FILE_PATH_ERROR_MSG =
  'The download filepath is empty';
export const PORTAL_DIV_ID = 'portal';
export const STORAGE_USER_INFO_PREFIX = 'oidc.user';
export const STORAGE_OIDC_DATA_PREFIX = 'oidc';
export const SAVE_SCHEDULING_TAB_INDEX = 2;
export const PARAMETER_TYPE_NAME = 'Parameter';
export const HEAP_REDACT_SENSITIVE_INFO = ['Staff', 'Company'];
export const ACCESS_DENIED_MSG = 'Access denied';
export const REPORT_SNAPSHOT_EXPIRED_MSG =
  'Report snapshot is expired and not available to download anymore';
